import { createAction } from '@housinganywhere/safe-redux';

// this function dispatches an action to redux only for the
// sake of tracking some analytics. You should use this
// only when you want to track something on anlytics when you don't have a
// redux action to map with analytics
export const track = (name, data = {}) =>
  createAction(
    'Analytics.track',
    { name, data },
    { analytics: { type: name, payload: data } },
  );
